import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

/**
 * 平面図凡例の表示可否
 * @type {RecoilState<boolean>}
 */
export const mapLegendVisibleState = atom({
  key: 'mapLegendVisibleState',
  default: selector({
    key: 'mapLegendVisibleStateSelector',
    get: () => {
      return getCustomerSettings('mapConfig.MAP_LEGEND');
    }
  })
});

/**
 * 平面図凡例リスト
 * @type {RecoilState<*[]>}
 */
export const mapLegendListState = atom({
  key: 'mapLegendListState',
  default: [],
  dangerouslyAllowMutability: true
});

/**
 * 平面図凡例リスト(groupingが設定されている場合、先勝ち)
 * @type {RecoilValueReadOnly<unknown>}
 */
export const mapLegendListSelector = selector({
  key: 'mapLegendListSelector',
  get: ({get}) => {
    const legendList = get(mapLegendListState);
    const groupingSet = new Set();
    return legendList.reduce((acc, legend)=>{
      if (legend.grouping !== undefined) {
        if (!groupingSet.has(legend.grouping)) {
          acc.push(legend);
        }
        groupingSet.add(legend.grouping);
      } else {
        acc.push(legend);
      }
      return acc
    },[])
  },
  dangerouslyAllowMutability: true
})

/**
 * アクティブな凡例のタブ
 * @type {RecoilState<unknown>}
 */
export const mapSelectedLegendState = atom({
  key: 'mapSelectedLegendState',
  default: undefined
});

/**
 * 平面図凡例リストに凡例情報を追加する
 */
export const addMapLegendSelector = selector({
  key: 'addMapLegendSelector',
  set: ({get, set}, legend) => {
    const oldList = get(mapLegendListState);
    const idx = oldList.findIndex(target => {
      return target.id === legend.id;
    });
    if (idx !== -1) return;
    const newList = [...oldList, legend];
    set(mapLegendListState, newList);
    set(mapSelectedLegendState, newList.length - 1);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});

/**
 * 平面図凡例リストから凡例情報を削除する
 */
export const removeMapLegendSelector = selector({
  key: 'removeMapLegendSelector',
  set: ({get, set}, legend) => {
    const oldList = get(mapLegendListState);
    const idx = oldList.findIndex(target => {
      return target.id === legend.id;
    });
    if (idx === -1) return;

    let activeTabIdx;
    if (oldList[idx - 1]) {
      activeTabIdx = idx - 1;
    } else if (oldList[idx + 1]) {
      activeTabIdx = idx;
    } else {
      activeTabIdx = 0;
    }
    const newList = [...oldList.slice(0, idx), ...oldList.slice(idx + 1)];
    set(mapLegendListState, newList);
    set(mapSelectedLegendState, activeTabIdx);
  },
  get: () => {},
  dangerouslyAllowMutability: true
});
